function getStyleFromSheet(selector: string, sheetId: string = '#THISTOO'): CSSStyleDeclaration {
  const styleSheet = document.querySelector<HTMLStyleElement>(sheetId);

  if (!styleSheet) return {} as CSSStyleDeclaration;

  const styleRules = Array.from((styleSheet.sheet as CSSStyleSheet).cssRules);

  let style: CSSStyleDeclaration = {} as CSSStyleDeclaration;

  for (let i = 0; i < styleRules.length; i++) {
    if (styleRules[i] instanceof CSSStyleRule) {
      const styleRule = styleRules[i] as CSSStyleRule;
      if (styleRule.selectorText === selector) {
        for (let j = 0; j < styleRule.style.length; j++) {
          const property = styleRule.style[j];
          style[property as any] = styleRule.style.getPropertyValue(property);
        }
      }
    }
  }

  return style;
}

export { getStyleFromSheet };
